/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useMemo } from 'react';
// import Slider from 'react-slick';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
import { Box, Stack, Typography } from '@mui/material';
// Wimss context
import { useWimssController } from 'context';

//import pictures
import BlueSky from 'assets/images/pictures/bluesky.png';
import SandyBeach from 'assets/images/pictures/sandy-beach.png';
import IndoorSchTable from 'pages/components/IndoorSchTable';
// import VBSchedule from 'schedules/vb_schedule_24_25.json';
// import PKBSchedule from 'schedules/pkb_schedule_24_25.json';
// import CombinedSchedules from 'schedules/schedules_combined.json';
import EventCalendar from './EventCalendar';

const ScheduleComponents = () => {
  const Yesterday = new Date(Date.now() - 86400000);
  const [controller, dispatch] = useWimssController();
  const { isMobile, currentTexts, currentTab } = controller;
  const columns = useMemo(() => [
    { field: 'date', headerName: 'Date', type: 'string', width: 130 },
    {
      field: 'dayOfWeek',
      headerName: 'Day of Week',
      type: 'string',
      width: 150,
    },
    {
      field: 'startTime',
      headerName: 'Start Time',
      type: 'string',
      width: 120,
    },
    {
      field: 'finishTime',
      headerName: 'Finish Time',
      type: 'string',
      width: 120,
    },
    { field: 'location', headerName: 'Location', type: 'string', width: 700 },
    { field: 'hours', headerName: 'Hours', type: 'number', width: 80 },
    { field: 'bookingNo', headerName: 'Booking #', type: 'string', width: 150 },
  ]);
  const [rows, setRows] = useState(null);

  // useEffect(() => {
  //   if (currentTab === 0)
  //     setRows(VBSchedule.filter((row) => Date.parse(row.date) >= Yesterday));
  //   if (currentTab === 1)
  //     setRows(PKBSchedule.filter((row) => Date.parse(row.date) >= Yesterday));
  // }, []);

  return (
    <Box
      sx={{
        backgroundImage: `url(${BlueSky})`,
        backgroundRepeat: 'repeat',
        overflow: 'auto',
        width: '100vw',
        height: '100%',

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}>
      {currentTexts !== null && currentTexts[0].paragraphs.length > 3 && (
        <Stack
          direction='column'
          justifyContent='center'
          alignItems='center'
          spacing={2}
          sx={{ mt: isMobile ? 4 : 6 }}>
          <Typography
            variant={isMobile ? 'body' : 'h4'}
            sx={{
              fontFamily: 'Questrial',
              fontWeight: 600,
              maxWidth: isMobile ? 350 : 800,
              textAlign: 'center',
            }}>
            {currentTexts[0].paragraphs[currentTab + 1].subtitle}
          </Typography>
          <Typography variant={isMobile ? 'h6' : 'h4'}> </Typography>
          <Typography
            variant={isMobile ? 'body' : 'h5'}
            sx={{
              fontFamily: 'Montserrat',
              textAlign: 'center',
              lineHeight: '150%',
              maxWidth: isMobile ? 350 : 800,
            }}>
            {currentTexts[0].paragraphs[currentTab + 1].content}
          </Typography>
          {rows !== null && (
            <Box sx={{ maxWidth: isMobile ? 350 : 1500 }}>
              {/* <IndoorSchTable rows={rows} columns={columns} /> */}
              <EventCalendar />
            </Box>
          )}
        </Stack>
      )}

      {currentTexts !== null && (
        <Box
          sx={{
            backgroundImage: `url(${SandyBeach})`,
            overflowY: 'auto',
            width: '100vw',
            height: 300,

            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}></Box>
      )}
    </Box>
  );
};

export default ScheduleComponents;
